module.exports = __webpack_public_path__ + "img/ring_g_s_0_0@2x.87783bc7.png";